/**
* BoxWithBorder component
* @returns <BoxWithBorder />
*/

const InputContainer = ({ title, subtitle, children, extraClass }) => {
    return (
        <div className={`input-container ${extraClass ? extraClass : ""} ${subtitle ? "--with-subtitle" : ""}`}>
            {title && (
                <h4 className="input-container__title">
                    <strong>{title}</strong>
                </h4>
            )}

            {subtitle && <p className="input-container__subtitle">{subtitle}</p>}

            {children}
        </div>
    )
}

export default InputContainer